module.exports = __webpack_public_path__ + "assets/img/bookmark.b1156e08.svg";